export default "__VITE_ASSET__1ee6753b__"